import { TextButton, theme } from '~components/web-components'
import { BookmarkFilledIcon } from '~components/icons'
import { Box, Typography } from '@mui/material'
import { ReactNode } from 'react'
import styled from 'styled-components'
import { COLORS } from '~theme/colors'
import { Z_INDEX } from '~types/z-index'

export const DocumentWrapper = ({
  onClickHandler,
  children,
}: {
  onClickHandler: () => void
  children: ReactNode
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', xxxl: 'row' },
        justifyContent: 'space-between',
        gap: { xs: 4, xxxl: 0 },
        backgroundColor: COLORS.greys.ultraLight,
        padding: 3,
        '&:hover': { backgroundColor: COLORS.secondary.notificationBlue },
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
      }}
      onClick={() => onClickHandler()}
    >
      {children}
    </Box>
  )
}

export const DocumentInfo = ({
  publishDate,
  title,
  category,
  vesselName,
}: {
  publishDate: string
  title: string
  category: string
  vesselName?: string
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="menu" color={COLORS.greys.dark}>
        {publishDate} | {category} {vesselName ? '|' : ''} {vesselName}
      </Typography>
      <Typography variant="paragraph1" sx={{ lineBreak: 'auto', mr: 4 }}>
        {title}
      </Typography>
    </Box>
  )
}

export const DocumentsWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'reverse-column', lg: 'row' },
      gap: theme.SPACINGS[1],
    }}
  >
    {children}
  </Box>
)

export const DocumentButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  & svg {
    width: 19px;
    height: 19px;
    cursor: pointer;
  }
`

export const FileIconWrapper = styled.div`
  width: 1.5em;
  height: 2.5em;
  display: grid;
  place-content: center;
`

export const ContentWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: theme.SPACINGS[2],
        alignItems: 'flex-start',
      }}
    >
      {children}
    </Box>
  )
}

export const FilterWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: theme.SPACINGS[1],
        whitespace: { xs: 'nowrap', md: 'normal' },
      }}
    >
      {children}
    </Box>
  )
}

export const FiltersWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  display: block;
  min-width: 30%;
`

export const FiltersInnerWrapper = styled.div<{ $isFiltersOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${theme.SPACINGS[3]};
  padding: ${theme.SPACINGS[3]} ${theme.SPACINGS[4]};
  background-color: ${COLORS.secondary.blueTint};
  height: fit-content;
`

export const DocumentSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${COLORS.greys.light};

  @media only screen and (${theme.BREAKPOINTS.sm}) {
    display: none;
  }
`

export const StyledTextButton = styled(TextButton)`
  color: ${COLORS.primary.maerskBlue};

  & svg path {
    fill: ${COLORS.primary.maerskBlue};
  }
`

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.SPACINGS[2]};
`

export const StyledFilterButton = styled(TextButton)`
  align-self: flex-end;
  font-size: 14px;
  z-index: ${Z_INDEX.MainNavUserMenu};
`

export const StyledBookmarkFilledIcon = styled(BookmarkFilledIcon)`
  color: ${COLORS.primary.maerskBlue};
`

export const BookmarkWrapper = styled.div`
  color: ${COLORS.greys.dark};
`
